export default __webpack_public_path__ + "static/mikrotik-hap-723tt-653520b4453fd44c592881a98cb155a0.jpg";